<template>
    <div class="con">
        <!-- <Card>
            <div class="title-complete">Complete</div>
            <div class="img-container">
                <img src="../assets/Group 158.png">
            </div>
            <p>Battery replacement is complete.</p>
            <span @click="routeTo('Station')">
                <Button class="complete-button">COMPLETE</Button>
            </span>
        </Card> -->
        <Card>
            <div class="change-complete">
                <div class="title-complete">Complete</div>
                <div class="img-container">
                    <img src="../assets/complete.png">
                </div>
                <p>Battery replacement is complete.</p>
                <span @click="routeTo('SelectStation')">
                    <Button class="next-btn">COMPLETE</Button>
                </span>
            </div>

        </Card>
    </div>
</template>
  
<script>
import Button from "../components/Button.vue"
import Card from "../components/Card.vue"


export default {
    name: "ChangeComplete",
    components: {
        Button,
        Card
    },
    data() {
        return {
            completeSlot: '',
            userId: '',
        }
    },
    methods: {
        routeTo(route) {
            if (!route) return
            console.log(route)
            this.$router.push({ name: route })
        },
        async updateStatus() {
            try {
                this.userId = localStorage.getItem('user_id');

                const currentTime = new Date().toISOString();
                let response = await this.$apiFire('User/onGetUserInfo', {
                    "date": currentTime,
                    "station_id": this.completeSlot.station_id,
                    "solt": this.completeSlot.no,
                    "user_id": this.userId
                })
                console.log('user api ', response);
                this.batteryStation = response;
            } catch (error) {
                console.log(error);
            }
        },
    },
    created() {
        this.completeSlot = this.$route.query.slot;
        // console.log(this.completeSlot)
        // console.log(this.completeSlot.id)
        console.log(this.completeSlot.no)
    },
}
</script>
  
<style scoped>
/* .title-complete {
    font-size: var(--font-m-large);
    font-weight: 700;
}

.img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 227px;
    width: 260px;
    border-radius: 16px;
    background: #FFF7EB;
    margin: 20px;

}

p {
    position: relative;
    font-size: var(--font-mini);
    color: var(--theme-one);
}

.complete-button {
    border-radius: 8px;
    min-height: 56px;
    min-width: 155px !important;
    color: var(--theme-four);
} */

.con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.change-complete {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 325px;
    height: 430px;
    padding: 24px;
}

.title-complete {
    font-size: 24px;
    font-weight: 700;
    /* margin-bottom: 30px; */
}

.img-container {
    width: 267px;
    height: 267px;
}

p {
    text-align: center;
    position: relative;
    font-size: 14px;
    color: var(--theme-one);
}

.next-btn {
    width: 155px !important;
    height: 56px !important;
    color: #fff;
    margin-top: 15px;
}
</style>